import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'; // Import useNavigate
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { getFirestore, doc, setDoc } from 'firebase/firestore';
import app from '../../services/firebase';
import ErrorBubble from '../ErrorBubble/ErrorBubble';

const RegisterPage = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const auth = getAuth(app);
  const db = getFirestore(app);
  const navigate = useNavigate(); // Initialize useNavigate

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!username || !email || !password || !confirmPassword) {
      setErrorMessage('All fields are required.');
      setTimeout(() => setErrorMessage(null), 3000); // Clear the error after 3 seconds
      return;
    }

    if (password !== confirmPassword) {
      setErrorMessage('Passwords do not match.');
      setTimeout(() => setErrorMessage(null), 3000); // Clear the error after 3 seconds
      return;
    }

    try {
      // Create the user with email and password
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Save the username and other details to Firestore
      await setDoc(doc(db, 'users', user.uid), {
        username,
        email,
      });

      // Add the user to the `monthlyData` collection
      const caloriesDocRef = doc(db, 'monthlyData', 'caloriesBurned');
      const stepsDocRef = doc(db, 'monthlyData', 'stepsTaken');

      // Initialize the user's totals to 0 in both documents
      await setDoc(
        caloriesDocRef,
        { [user.uid]: { total: 0 } },
        { merge: true } // Merge to avoid overwriting existing data
      );
      await setDoc(
        stepsDocRef,
        { [user.uid]: { total: 0 } },
        { merge: true } // Merge to avoid overwriting existing data
      );

      setErrorMessage(null); // Clear any previous errors
      console.log('User registered and added to monthlyData successfully!');

      // Navigate to the main page
      navigate('/main');
    } catch (error) {
      console.error('Error during registration:', error);
      setErrorMessage('Failed to register. Please try again.');
      setTimeout(() => setErrorMessage(null), 3000); // Clear the error after 3 seconds
    }
  };

  return (
    <div className="page-container">
      <h1>Register</h1>
      {/* Error Bubble */}
      <ErrorBubble message={errorMessage} />
      <form className="auth-form" onSubmit={handleRegister}>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
        <button type="submit">Register</button>
      </form>
      <p>
        Already have an account? <Link to="/">Login here</Link>
      </p>
    </div>
  );
};

export default RegisterPage;